<template>
  <div class="white-container" :key="$store.getters['resource/currentResource'].key" v-if="show">
    <promo-view
      @save="savePromo"
      :params="this.$route.params"
    >
    </promo-view>

  </div>
</template>

<script>
  import PromoView from "./PromoView.vue";

  export default {
    components: {PromoView},
      middleware: 'auth',
    name: 'PromoEditing',
    data: () => {
      return {
        show: false,
      }
    },

    created() {
      this.show = !!this.$route.params.id;
      if (!this.$route.params.id) {
        this.$router.push({path: '/promos'})
      }
    },
    methods: {
      savePromo(params) {
        this.putData(`promos/${params.id}`, params, '/promos');
      },
    }
  }
</script>